module.exports = __webpack_public_path__ + "img/auto.8d9bd4ce.svg";